import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from '@kodit/core/shared-ui';
import { AlertService } from '@kodit/core/services';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { KreiranjePrijemniceFormService } from '../../prijemnice/kreiranje-prijemnice-form.service';

@Component({
  selector: 'kodit-add-komentar-stavke-prijemnice',
  templateUrl: './add-komentar-stavke-prijemnice.component.html',
  styleUrls: ['./add-komentar-stavke-prijemnice.component.scss']
})
export class AddKomentarStavkePrijemniceComponent implements OnInit, OnDestroy {

  stavkePrijemnice: FormArray;
  form: FormGroup;

  /** Subs */
  private _subs: Subscription = new Subscription();

  constructor(
    private _dialogRef: DynamicDialogRef,
    private _alertService: AlertService,
    public dialogConfig: DynamicDialogConfig,
    private _fs: KreiranjePrijemniceFormService,
    private _fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.stavkePrijemnice = this._fs.getStavkeArray;
    this.form =  this._fb.group({
      komentar : new FormControl(this.stavkePrijemnice.at(this.dialogConfig.data.index)?.value.komentar)
    })

    this._subs.add(
      this._dialogRef.onSubmit.subscribe(() => {
        this.save();
      })
    );
  }

  private save(): void {
    this.stavkePrijemnice.at(this.dialogConfig.data.index).patchValue({
      komentar: this.form.value.komentar
    })
    this._dialogRef.close();
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }

}
